function CommunitySection() {
  return (
    <section id="community" className="ac-community">
      <div className="ac-width ac-section-lead">
        <h2>Nemáme<br />týdenní rozvrh.</h2>
        <div>
          <p>Hrajeme, posloucháme, občas někdo hodí obrázek. Někdo tam visí i pozdě.</p>
          <p>Když se něco chystá, bavíme se o tom na Discordu. Plán je tam.</p>
          <a href="https://discord.allcom.zone" className="ac-text-link" target="_blank" rel="noopener noreferrer">Podívat se na Discord</a>
        </div>
      </div>
    </section>
  )
}

export default CommunitySection
